import React from "react"
import { styled } from "../stitches.config"
import {
    format,
    isSameDay,
    isDate
} from 'date-fns'
import { pl } from "date-fns/locale"

import { drawCalendar } from "../helpers/drawCalendar"

const DAYS = ["Pon", "Wt", "Śr", "Czw", "Pt", "Sob", "Nd"]

const Calendar = ({ year, month, answers }) => {
    const calendar = drawCalendar({ year, month }, (day, { isSameMonth }) => (isSameMonth ? day : '--')).map(el => el.map((day, i) => {
        let dayType = 'none';

        if (isSameDay(day, answers.ovulation)) {
            dayType = 'ovulation';
        } else if (answers.highest.some(date => isSameDay(day, date))) {
            dayType = 'high';
        } else if (answers.medium.some(date => isSameDay(day, date))) {
            dayType = 'medium';
        } else if (answers.lowest.some(date => isSameDay(day, date))) {
            dayType = 'low';
        }

        return isDate(day)
            ? <Cell
                key={i}
                dayType={dayType}
                isOvulation={isSameDay(day, answers.ovulation)}>
                {format(day, 'dd')}
            </Cell>
            : <Cell key={i}>
                {day}
            </Cell>
    }))

    return (
        <Wrap>
            <span>{format(new Date(year, month), "MMM yyyy", { locale: pl })}</span>
            <div>
                {DAYS.map((day, i) => <Cell key={i} isWeekdayName={true}>{day}</Cell>)}
                {calendar}
            </div>
        </Wrap>
    )
}

const Cell = styled("div", {
    position: "relative",
    padding: "5px",
    color: "#777",
    borderBottom: "2px solid",
    borderColor: "$primary",
    "&:after": {
        content: " ",
        width: "5px",
        height: "5px",
        borderRadius: "5px",
        left: "calc(50% - 2px)",
        top: "calc(50% + 8px)",
        backgroundColor: "#FFB648"
    },
    "@bp4": {
        padding: "6px 18px"
    },
    variants: {
        isWeekdayName: {
            true: {
                color: "#333"
            },
            false: {}
        },
        dayType: {
            high: {
                color: "#fff",
                backgroundColor: "#FF2E57"
            },
            medium: {
                color: "#fff",
                backgroundColor: "#FF6180"
            },
            low: {
                color: "#fff",
                backgroundColor: "#FF94A9"
            },
            none: {
                backgroundColor: "transparent"
            }
        },
        isOvulation: {
            true: {
                color: "#fff",
                backgroundColor: "#FF2E57",
                "&:after": {
                    position: "absolute"
                }
            },
            false: {
                "&:after": {
                    position: "hidden"
                }
            }
        }
    }
});

const Wrap = styled("div", {
    marginTop: "20px",
    "&>div": {
        marginTop: "20px",
        display: "grid",
        gridTemplateColumns: "repeat(7, 1fr)"
    },
    "@bp4": {
        "&>div": {
            margin: "0 20px"
        }
    }
});

export default Calendar